import _ from 'lodash'
import BaseViewModel from '../../../infraestructure/BaseViewModel'
import Evaluation from '../models/Evaluation'

export default class EvaluationViewModel extends BaseViewModel {
  constructor(view) {
    super(view)
  }
  // INICIALIZADORES

  //#region CRUD

  onCreate() {
    let item = new Evaluation({
      state: "create",
      status: 1
    });
    return item;
  }

  onDelete(data) {
    let item = new Evaluation(data);
    item.state = "delete";
    return item;
  }

  onEdit(data) {
    let item = new Evaluation(data);
    item.state = "update";
    return item;
  }

  onSearchCollection() {
    return this.api.evaluations.find(this.getSearchQuery())
  }

  mapCollection(collection) {
    return _.map(collection, (data) => new Evaluation(data));
  }

  onSearchItem(id) {
    return this.api.evaluations.findOne(id)
  }

  onSave(data) {
    const payload = data.toSend();

    // El flujo administrativo exige estudiante y curso: si faltan, se avisa
    // con un mensaje claro en lugar de dejar que el backend receive null.
    if (!payload.studentId || !payload.courseId) {
      return Promise.reject(new Error('Selecciona estudiante y curso antes de guardar la evaluación.'));
    }

    if (data.state === 'create')
      return this.api.evaluations.create(payload)
    else
      return this.api.evaluations.update(data.id, payload);
  }

  onDestroy(context, id) {
    context.api.evaluations.delete(id)
        .then(response => context.view.onSuccess(response.data))
        .catch(context.view.onError)
}

  onCancel(context) {
    context.view.item = null;
  }

  import(file) {
    this.api.evaluations.import(file)
      .then(response => this.view.onImportResponse(response.data))
      .catch(this.view.onError)
  }

  exportToExcel() {
    this.api.evaluations.exportToExcel()
      .then(response => this.view.onExportResponse(response.data))
      .catch(this.view.onError)
  }

  // #endregion

  // #region BINDING DATA

  bindFormView() {
    if (this.view.formData.state === 'update') {
      this.api.students.find()
        .then((response) => {
          this.view.students = response.data.data
          return this.api.courses.find()
        })
        .then((response) => {
          this.view.courses = response.data.data
        })
        .catch(this.view.onError)
    }
    setTimeout(() => {
      this.showModalLoading(this.view.conf, false);
    }, 400);
  }

  // #endregion

  // #region QUERIES
  /**
   * Metodo para buscar estudiantes
   * @param {String} data Query string para parametros de búsqueda
   */
  findStudents(data) {
    this.api.students.find(data)
      .then((response) => this.view.onSearchStudentsResponse(response.data.data))
      .catch(this.view.onError)
  }
  /**
   * Metodo para buscar cursos
   * @param {String} data Query string para parametros de búsqueda
   */
  findCourses(data) {
    this.api.courses.find(data)
      .then((response) => this.view.onSearchCoursesResponse(response.data.data))
      .catch(this.view.onError);
  }

  // #endregion

  //#region MAPPING DATA

  
  // #endregion

  // #region VALIDATIONS

  // #endregion
}
